import { useTranslation } from "react-i18next";
import { NavLink } from "../../app/NavBar/NavBarElements";
import { ReactElement } from "react";
import { useLocation } from "react-router-dom";
import { conditionallyHighlighted } from "../../../utils/cssUtils";

const CreateActionLink = (): ReactElement => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  return (
    <NavLink
      to="/akcije/nova"
      highlighted={conditionallyHighlighted(pathname, "/akcije/nova")}
    >
      {t("createAction")}
    </NavLink>
  );
};

export default CreateActionLink;
